import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=7134728c&scoped=true&"
import script from "./Content.vue?vue&type=script&setup=true&lang=js&"
export * from "./Content.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134728c",
  null
  
)

export default component.exports